export default "__VITE_ASSET__0571d5ea__"